// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
//import { getAuth } from "firebase/auth";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBOFKBEcG1QQ-aLqBa1RvB7UCevfrQIh2s",
  authDomain: "marknotes-d9036.firebaseapp.com",
  projectId: "marknotes-d9036",
  storageBucket: "marknotes-d9036.appspot.com",
  messagingSenderId: "416865887341",
  appId: "1:416865887341:web:ba8514ec639c647fefcb64",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
//export const auth = getAuth(app);
